import React, { useState, useContext } from 'react';
import VendorLoginModal from './VendorLoginModal';
import DrivingSchoolAuthModal from './DrivingSchoolAuthModal';
import AgentAuthModal from './AgentAuthModal';
import { AuthContext, useAuth } from '../context/AuthContext';
import { Link, useNavigate } from 'react-router-dom';

export default function Footer() {
    const [showVendorModal, setShowVendorModal] = useState(false);
    const [isVendorRegisterView, setIsVendorRegisterView] = useState(false);
    const [showDrivingSchoolModal, setShowDrivingSchoolModal] = useState(false);
    const [isRegisterView, setIsRegisterView] = useState(false);
    const [showAgentModal, setShowAgentModal] = useState(false);
    const [isAgentRegisterView, setIsAgentRegisterView] = useState(false);

    const { logoutUser } = useContext(AuthContext);
    const { viewMode } = useAuth();
    const navigate = useNavigate();

    const handleVendorClick = (e, register = false) => {
        e.preventDefault();
        if (viewMode === 'vendor') {
            navigate('/vendor/dashboard');
        } else {
            setIsVendorRegisterView(register);
            setShowVendorModal(true);
        }
    };

    const handleDrivingSchoolClick = (e, register = false) => {
        e.preventDefault();
        if (viewMode === 'school') {
            navigate('/school/dashboard');
        } else {
            setIsRegisterView(register);
            setShowDrivingSchoolModal(true);
        }
    };

    const handleLogout = (e) => {
        e.preventDefault();
        logoutUser();
        navigate('/');
    };

    const handleAgentClick = (e, register = false) => {
        e.preventDefault();
        if (viewMode === 'agent') {
            navigate('/agent/dashboard');
        } else {
            setIsAgentRegisterView(register);
            setShowAgentModal(true);
        }
    };

    return (
        <>
            <section className="footer-style-two">
                <div className="footer-top">
                    <div className="auto-container">
                        <div className="row clearfix">

                            {/* About */}
                            <div className="col-lg-4 col-md-6 col-sm-12 footer-column">
                                <div className="footer-widget logo-widget">
                                    <h1 className="text-white">Asysta India Private Limited</h1>
                                    <p>
                                        Asysta connects learners with trusted driving schools, helps users
                                        access verified vendor services, and makes it easy to discover and
                                        buy driving-related products from one platform.
                                    </p>
                                    <div className="rating-box">
                                        <h4>Excellent</h4>
                                        <ul className="rating clearfix">
                                            {[...Array(4)].map((_, i) => (
                                                <li key={i}><i className="flaticon-star"></i></li>
                                            ))}
                                            <li><i className="flaticon-star-half-empty"></i></li>
                                        </ul>
                                        <p>Trust Score 4.5 (2,500+ Reviews)</p>
                                    </div>
                                </div>
                            </div>

                            {/* Useful Links */}
                            <div className="col-lg-4 col-md-6 col-sm-12 footer-column">
                                <div className="footer-widget links-widget text-white">
                                    <h4>Useful Links</h4>
                                    <ul className="links-list clearfix">
                                        <li><Link to="/about">About Us</Link></li>
                                        <li><Link to="/courses">Courses</Link></li>
                                        <li><Link to="/services">Services</Link></li>
                                        <li><Link to="/product">Products</Link></li>
                                        <li><Link to="/mocktest">Mock Test</Link></li>
                                        <li><Link to="/contact">Contact Us</Link></li>
                                    </ul>
                                </div>
                            </div>

                            {/* Actions */}
                            <div className="col-lg-4 col-md-6 col-sm-12 footer-column">
                                <div className="footer-widget links-widget text-white">
                                    <h4>Quick Access</h4>
                                    <ul className="links-list clearfix">
                                    
                                        <li><a href="#">How Its Works</a></li>
                                        <li><a href="#">Rules & Signs</a></li>
                                        <li><a href="#">Safety Guide</a></li>

                                        <li>
                                            {viewMode === 'vendor' ? (
                                                <>
                                                    <a href="#" onClick={() => navigate('/vendor/dashboard')}>
                                                        Vendor Dashboard
                                                    </a>
                                                    <span
                                                        onClick={handleLogout}
                                                        style={{ marginLeft: 10, color: '#ff6b6b', cursor: 'pointer' }}
                                                    >
                                                        (Logout)
                                                    </span>
                                                </>
                                            ) : (
                                                <>
                                                    <a href="#" onClick={(e) => handleVendorClick(e, false)}>
                                                        Vendor Login
                                                    </a>
                                                    <span className="mx-2 text-white-50">|</span>
                                                    <a href="#" onClick={(e) => handleVendorClick(e, true)}>
                                                        Vendor Register
                                                    </a>
                                                </>
                                            )}
                                        </li>

                                        <li>
                                            {viewMode === 'school' ? (
                                                <>
                                                    <a href="#" onClick={() => navigate('/school/dashboard')}>
                                                        School Dashboard
                                                    </a>
                                                    <span
                                                        onClick={handleLogout}
                                                        style={{ marginLeft: 10, color: '#ff6b6b', cursor: 'pointer' }}
                                                    >
                                                        (Logout)
                                                    </span>
                                                </>
                                            ) : (
                                                <a href="#" onClick={(e) => handleDrivingSchoolClick(e, true)}>
                                                    Register Driving School
                                                </a>
                                            )}
                                        </li>

                                        <li>
                                            {viewMode === 'agent' ? (
                                                <>
                                                    <a href="#" onClick={() => navigate('/agent/dashboard')}>
                                                        Agent Dashboard
                                                    </a>
                                                    <span
                                                        onClick={handleLogout}
                                                        style={{ marginLeft: 10, color: '#ff6b6b', cursor: 'pointer' }}
                                                    >
                                                        (Logout)
                                                    </span>
                                                </>
                                            ) : (
                                                <a href="#" onClick={(e) => handleAgentClick(e, false)}>
                                                    Agent Login / Register
                                                </a>
                                            )}
                                        </li>
                                    </ul>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                {/* Footer Bottom */}
                <div className="footer-bottom">
                    <div className="auto-container">
                        <div className="bottom-inner footer-legal-row">
                            <p className="footer-legal-text">
                                © 2026 <strong>Asysta</strong>. All rights reserved. Asysta is a platform that connects users with independent driving schools. We do not provide driving training ourselves. By using this website, you agree to our Terms of Use, Privacy Policy, Refund Policy, and Disclaimer.
                            </p>
                            <ul className="footer-nav footer-legal-links">
                                <li><Link to="/refund-cancellation-policy">Refund & Cancellation Policy</Link></li>
                                <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                                <li><Link to="/terms-of-use">Terms of Use</Link></li>
                                <li><Link to="/disclaimer">Disclaimer</Link></li>
                              
                            </ul>
                        </div>
                    </div>
                </div>
            </section>

            {/* Modals */}
            <VendorLoginModal
                show={showVendorModal}
                onClose={() => {
                    setShowVendorModal(false);
                    setIsVendorRegisterView(false);
                }}
                isRegister={isVendorRegisterView}
            />

            <DrivingSchoolAuthModal
                show={showDrivingSchoolModal}
                onClose={() => setShowDrivingSchoolModal(false)}
                isRegister={false}
            />

            <AgentAuthModal
                show={showAgentModal}
                onClose={() => setShowAgentModal(false)}
                isRegister={isAgentRegisterView}
            />
        </>
    );
}

